import { Button, media, styled } from '@payright/web-components';
import SCSpinner from '../../../components/spinner';
import { LoanPurposeField } from './loan-purpose-field';
import { SectionHeader } from './section-header';
import { ButtonCancelPlan } from '../../../components/buttons/ButtonCancelPlan';

const SCDiv = styled.div`
  display: grid;
  gap: 1rem;
  text-align: center;
  ${media.min.tablet} {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }
`;

const SCButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  ${media.min.tablet} {
    flex-direction: row-reverse;
  }
`;

type LoanPurposeFormProps = {
  isDisabled: boolean;
  isSubmitting: boolean;
  loanAmount: number;
  loanPurpose: string;
  storeName: string;
  onContinue: () => void;
};

export const LoanPurposeForm = ({
  isDisabled,
  isSubmitting,
  loanAmount,
  loanPurpose,
  storeName,
  onContinue,
}: LoanPurposeFormProps) => {
  return (
    <>
      <SCDiv>
        <SectionHeader>
          You are applying for a BNPL product with Payright so you can purchase goods and services
          from Payright merchants and pay for those purchases over time in bite size instalments.
        </SectionHeader>
        <SectionHeader>
          You wish to immediately make a purchase using your BNPL plan (rather than using another
          type of credit facility or making a savings plan) for an amount of{' '}
          {new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
          }).format(loanAmount)}{' '}
          to purchase:
        </SectionHeader>
        <LoanPurposeField loanPurpose={loanPurpose} storeName={storeName} />
        <SectionHeader>
          from {storeName} for your own personal use.
          <br /> Is this correct?
        </SectionHeader>
      </SCDiv>
      <SCButtonsContainer>
        <Button
          withShadow
          maxWidth="100%"
          iconPosition="right"
          disabled={isDisabled || isSubmitting}
          icon={isSubmitting ? <SCSpinner /> : undefined}
          handleClick={onContinue}
        >
          Yes, continue
        </Button>
        <ButtonCancelPlan disabled={isDisabled || isSubmitting} />
      </SCButtonsContainer>
    </>
  );
};
